import { render, staticRenderFns } from "./ChangesHistoryFilters.vue?vue&type=template&id=5166064d&scoped=true"
import script from "./ChangesHistoryFilters.vue?vue&type=script&lang=js"
export * from "./ChangesHistoryFilters.vue?vue&type=script&lang=js"
import style0 from "./ChangesHistoryFilters.vue?vue&type=style&index=0&id=5166064d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5166064d",
  null
  
)

export default component.exports